import React, { Component } from 'react'
import * as styles from './recommendtop.module.css'

export default class Recommendtop extends Component {

  render() {
    const recommend = this.props.recommend
    const maxCnt = 5
    let stars = ''
    let unstar = ''
    for (let i = 0; i < recommend; i++) stars += '★'
    for (let j = recommend; j < maxCnt; j++) unstar += '★'
    return (
      <span>
        <span className={styles.star}>{stars}</span>
        <span className={styles.unstar}>{unstar}</span>
      </span>
    )
  }
}